import { Injectable } from '@angular/core';

import { AutomatedMarqueeTilesConfig } from '@frontend/sports/common/client-config-data-access';
import { DarkModeService } from '@frontend/vanilla/shared/dark-mode';

@Injectable({ providedIn: 'root' })
export class AutomatedMarqueeImageService {
    constructor(
        private automatedMarqueeTilesConfig: AutomatedMarqueeTilesConfig,
        private darkModeService: DarkModeService,
    ) {}

    getImages(sportId: number, competitionId: number): string[] {
        const isDarkMode = this.darkModeService.isEnabled;

        const sportAndCompetitionImages = this.automatedMarqueeTilesConfig.automatedMarqueesTileImages.filter(
            (x) => x.sportId === sportId && x.competitionId === competitionId && x.isDarkMode === isDarkMode,
        );
        if (sportAndCompetitionImages.length) {
            return sportAndCompetitionImages.map((x) => x.imageSrc);
        }
        const sportImages = this.automatedMarqueeTilesConfig.automatedMarqueesTileImages.filter(
            (x) => x.sportId === sportId && x.competitionId === 0 && x.isDarkMode === isDarkMode,
        );
        if (sportImages.length) {
            return sportImages.map((x) => x.imageSrc);
        }
        const fallbackImages = this.automatedMarqueeTilesConfig.automatedMarqueesTileImages.filter(
            (x) => x.sportId === 0 && x.competitionId === 0 && x.isDarkMode === isDarkMode,
        );
        if (fallbackImages.length) {
            return fallbackImages.map((x) => x.imageSrc);
        }

        return [];
    }
}
